
  
  export default {
      name: "HappyKidsSubcategoryOptions",
      props: {
          data: {
              type: Array,
              default: () => ([]),
          },
      },
      data() {
          return {
            buttonStyle: {
              normal: {
                backgroundColor: 'transparent',
                textColor: '#16B7A6',
                borderColor: '#16B7A6',
              },
              active: {
                backgroundColor: '#16B7A6',
                textColor: '#white',
                borderColor: '#16B7A6',
                
              }
            },
            subcategoryOptions: [
                {
                    link: '/happy-kids/2023/before-birth/medical',
                    icon: 'cross',
                    isActive: true,
                    target: '_self',
                    text: "醫療 / 懷孕保障",
                    slug: "medical"
                },
                {
                    link: '/happy-kids/2023/before-birth/critical-illness',
                    icon: 'critical',
                    isActive: false,
                    target: '_self',
                    text: "危疾",
                    slug: "critical illness"
                },
                {
                    link: '/happy-kids/2023/before-birth/critical-illness',
                    icon: 'term-life',
                    isActive: false,
                    target: '_self',
                    text: "人壽",
                    slug: "critical illness"
                },
                {
                    link: '/happy-kids/2023/before-birth/critical-illness',
                    icon: 'education',
                    isActive: false,
                    target: '_self',
                    text: "教育基金",
                    slug: "critical illness"
                },
                {
                    link: '/happy-kids/2023/before-birth/critical-illness',
                    icon: 'money',
                    isActive: false,
                    target: '_self',
                    text: "財富傳承",
                    slug: "critical illness"
                },
              ]
          };
      },
      computed: {
        subcategories() {
          return (this.data?.length > 1) ? this.data : null
        }
      },
  
      watch: {
        subcategories(newValue, oldValue) {
            if (newValue !== oldValue) {
              console.debug('subcategories in subcat option changed...')
            }
          }
      },

      methods: {
        prepareButtonData(isActive, title, slug) {
          const data = {}
          if (isActive) {
            return Object.assign(data , {
              text: title, 
              icon: 'arrow', 
              buttonColor: this.buttonStyle.active.backgroundColor, 
              buttonBorderColor: this.buttonStyle.active.borderColor,
              textColor: this.buttonStyle.active.textColor,
              disabled: true,
            })
          } else {
            return Object.assign(data , {
              text: title, 
              icon: 'arrow', 
              buttonColor: this.buttonStyle.normal.backgroundColor, 
              buttonBorderColor: this.buttonStyle.normal.borderColor,
              textColor: this.buttonStyle.normal.textColor,
              link: '/happy-kids/' + this.$route.params.year + '/' + 'before-birth'
            })
          }
        },
  
        isSubcategoryValid() {
          return this.subcategories?.find((item) => item?.Slug === this.$route?.params?.productSubCat )
        },
  
        isActive(slug,index) {
          if (this.$route?.params?.productSubCat === slug) {
            return true
          }
          if (!this.$route.params.productSubCat && index === 0) {
            return true
          }
          return false
        },
        
        classNames(slug,index) {
          const classes = []
          classes.push(slug)
          
          if (this.isActive(slug,index)) {
            classes.push('active')
          }
          if (this.isActive(slug,index)) {
            classes.push('active')
          }
          return classes
        },
      },
  
  }
  